/* Account search for checking against existing account names */
import graphql from 'babel-plugin-relay/macro';
import { fetchQuery } from 'react-relay';
import AbEnvironment from '../auth/AbEnvironment'; 
  
const abEnvironment = new AbEnvironment();
const query = graphql`
query AccountSearchFetchQuery($accountName: String) {
    accountsearchbyaccountnameplusorder(accountName: $accountName) {
      totalCount
      nodes {
        accountName
        accountType
      }
    }
  }
  
`;

/**
 * 
 * @param {String} accountName name of account being queried
 * @returns 
 */
function fetch(accountName) {
  const variables = {
    accountName: accountName,
  }
  
  return fetchQuery(
      abEnvironment.getEnvironment(),
      query,
      variables
  );
}
/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default { fetch };